export enum paymentArt {
    default,
    perDrive,
    perDay
}
